module.exports = __webpack_public_path__ + "img/hk.106d5716.png";